import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ChatInnerComponent } from './chat-inner.component';
import { TimezoneDatePipe } from 'src/app/_metronic/shared/pipes/timezone-date.pipe';
import { SharedModule } from 'src/app/_metronic/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ChatInnerComponent],
  imports: [CommonModule, InlineSVGModule, SharedModule, TranslateModule],
  exports: [ChatInnerComponent],
})
export class ChatInnerModule {}
